import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';

const useUpdateEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const update = useCallback(async ({ email }, { onSuccess }) => {
    setIsLoading(true);

    try {
      const user = await Auth.currentAuthenticatedUser();

      await Auth.updateUserAttributes(user, {
        email,
        'custom:email_to_be_updated': email,
      });

      setIsLoading(false);
      onSuccess();
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  }, []);

  return { update, isLoading, error };
};

export default useUpdateEmail;
